import { StyledEngineProvider, ThemeOptions, ThemeProvider } from "@mui/material/styles";
import React, { PropsWithChildren, useContext } from "react";
import { createTenantTheme } from "./config";
import { TenantContext } from "../tenant-context";
import { usePropertyConfig } from "../hooks";

export interface MultitenantThemeProviderProps {
  overrideComponents: (themeName: string) => ThemeOptions;
  overrideTheme?: string;
  origin?: string;
  children?: React.ReactNode;
}

export const TenantThemeProvider: React.FC<PropsWithChildren<MultitenantThemeProviderProps>> = ({
  children,
  overrideComponents,
  overrideTheme,
  origin
}) => {
  const { theme: selectedTheme } = useContext(TenantContext);
  const { theme: urlTheme } = usePropertyConfig({ origin });

  const multiTenantTheme = createTenantTheme(
    overrideTheme || urlTheme || selectedTheme,
    overrideComponents(selectedTheme)
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={multiTenantTheme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
};
